"use strict";

exports.__esModule = true;
exports.IS_BUILT_IN = void 0;
var IS_BUILT_IN = Symbol('IS_BUILT_IN');
exports.IS_BUILT_IN = IS_BUILT_IN;
//# sourceMappingURL=symbols.js.map